import React from "react";
import { AddOnsSortTypes } from "../../../configs/sortTypes";
import { AddOnsFilterType } from "../../../configs/filterTypes";
import { AddOnRow } from "./AddOnTable";
import ListView from "../../../shared/components/ListView";
import { TableColumns, Search } from "../../../configs/addons";

const Content = () => {
    return (
        <ListView
            url="/addons/"
            sortTypes={AddOnsSortTypes}
            filterTypes={AddOnsFilterType}
            rowElement={AddOnRow}
            tableColumns={TableColumns}
            textString={Search.searchText}
        />
    );
};

export default Content;
